import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const SIDE_MENU_COLLAPSED_STORAGE_KEY = "rosemount.sideMenuCollapsed";

const getInitialCollapsed = () => {
  try {
    return localStorage.getItem(SIDE_MENU_COLLAPSED_STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};

interface SideMenuInterface {
  title: string;
  isClicked: boolean;
  hideSideMenuBar: boolean;
  isCollapsed: boolean;
}

const initialState: SideMenuInterface = {
  title: "",
  isClicked: false,
  hideSideMenuBar: false,
  isCollapsed: getInitialCollapsed(),
};

export const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    setSideMenuOption: (state, action: PayloadAction<string>) => {
      const title = action.payload;
      if (state.title === title) {
        state.isClicked = !state.isClicked;
      } else {
        state.title = title;
        state.isClicked = true;
      }
    },
    setShowSideMenuBar: (state, action: PayloadAction<boolean>) => {
      state.hideSideMenuBar = action.payload;
    },
    setSideMenuCollapsed: (state, action: PayloadAction<boolean>) => {
      state.isCollapsed = action.payload;
      try {
        localStorage.setItem(
          SIDE_MENU_COLLAPSED_STORAGE_KEY,
          String(action.payload),
        );
      } catch {
        // Ignore storage failures so collapse still works in-memory.
      }
    },
  },
});

export const { setSideMenuOption, setShowSideMenuBar, setSideMenuCollapsed } =
  sideMenuSlice.actions;
export const sideMenuReducer = sideMenuSlice.reducer;
